import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { java } from "@codemirror/lang-java";

const JavaCodeEditorTerminal = () => {
  const [code, setCode] = useState(
    `public class Main {
  public static void main(String[] args) {
    System.out.println("Hello from Java");
  }
}`
  );
  const [output, setOutput] = useState("");

  const runCode = () => {
    setOutput(
      "⚠️ Java execution not supported in pure React. Needs CheerpJ or backend."
    );
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ flex: 1, position: "relative" }}>
        <button
          onClick={runCode}
          style={{
            position: "absolute",
            top: "10px",
            right: "30px",
            zIndex: 10,
            padding: "10px 20px",
            background: "#333",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Run ▶
        </button>
        <CodeMirror
          value={code}
          height="82vh"
          extensions={[java()]}
          onChange={setCode}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#1e1e1e",
          color: "#fff",
          padding: "10px",
        }}
      >
        <h4>Output:</h4>
        <pre>{output}</pre>
      </div>
    </div>
  );
};

export default JavaCodeEditorTerminal;
